import React from "react";
import "assets/styles/preloader.scss";
const Preloader = () => {
  return (
    <div className="wrapperWrapper">
      <div className="wrapper">
        <svg className="pl3" viewBox="0 0 128 128" width="128px" height="128px">
          <g fill="hsl(223,90%,50%)">
            <rect className="pl3__rect" rx="8" ry="8" width="64" height="64" transform="translate(64,0)" />
            <g className="pl3__rect-g" transform="scale(-1,-1)">
              <rect className="pl3__rect" rx="8" ry="8" width="64" height="64" transform="translate(64,0)" />
            </g>
          </g>
          <g fill="#F96167" mask="url(#pl-mask)">
            <rect className="pl3__rect" rx="8" ry="8" width="64" height="64" transform="translate(64,0)" />
            <g className="pl3__rect-g" transform="scale(-1,-1)">
              <rect className="pl3__rect" rx="8" ry="8" width="64" height="64" transform="translate(64,0)" />
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
};

export default Preloader;
